// Anzeigename eines Mitarbeiters: voller Name, wenn im Profil gepflegt —
// sonst ein lesbarer Name aus dem E-Mail-Lokalteil ("kristin.guz" →
// "Kristin Guz") statt der rohen Adresse. Spiegel der DB-Funktion
// callcenter_telefonie.display_name(), damit Dropdowns und Admin-Listen
// dieselben Namen zeigen wie die Auswertungs-Views.
export function anzeigeName(
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
): string {
  const name = [firstName, lastName].map((t) => t?.trim()).filter(Boolean).join(' ');
  if (name) return name;
  const lokal = (email ?? '').split('@')[0];
  const huebsch = lokal
    .replace(/-[0-9a-f]{6,}$/i, '') // generierter Konto-Suffix ("standort-20a30693")
    .split(/[._-]+/)
    .filter(Boolean)
    .map((t) => t.charAt(0).toUpperCase() + t.slice(1))
    .join(' ');
  return huebsch || email || '—';
}
